/* eslint-disable camelcase */
import { routes } from '@/routes'
import { useNavigation } from '@sevenrooms/navigation'

export const useAlertsRoute = () => {
  const { matchQuery } = useNavigation()
  const { request_id, party_size, start_time, end_time, date } = matchQuery(routes.reservations.alerts) ?? {}

  return {
    requestId: request_id ?? '',
    partySize: party_size,
    startTime: start_time,
    endTime: end_time,
    date,
  }
}
